export const CREATE_OVERRIDDING_RISKFACTOR = 'src/component/RiskFactor/OverriddingRiskFactor/create/Create_Overridding_Riskfactor';
export const CREATE_OVERRIDDING_RISKFACTOR_SUCCESSFULL = 'src/component/RiskFactor/OverriddingRiskFactor/create/Create_Overridding_Riskfactor_Successfull';
export const CREATE_OVERRIDDING_RISKFACTOR_FAILURE = 'src/component/RiskFactor/OverriddingRiskFactor/create/Create_Overridding_Riskfactor_Failure';

export const createOverriddingRiskFactor = (data) => {
    return {
        type: CREATE_OVERRIDDING_RISKFACTOR,
        data
    }
}
export const createOverriddingRiskFactorSuccess = (data) => {
    return {
        type: CREATE_OVERRIDDING_RISKFACTOR_SUCCESSFULL,
        data
    }
}
export const createOverriddingRiskFactorFailure = (data) => {
    return {
        type: CREATE_OVERRIDDING_RISKFACTOR_FAILURE,
        data
    }
}

export const FETCH_OVERIDDING_RISKFACTOR_DETAILS = 'src/component/RiskFactor/OverriddingRiskFactor/create/Fetch_Overridding_Riskfactor_Details';
export const FETCH_OVERIDDING_RISKFACTOR_DETAILS_SUCCESS = 'src/component/RiskFactor/OverriddingRiskFactor/create/Fetch_Overridding_Riskfactor_Details_Success';
export const FETCH_OVERIDDING_RISKFACTOR_DETAILS_FAILURE = 'src/component/RiskFactor/OverriddingRiskFactor/create/Fetch_Overridding_Riskfactor_Details_Failure';

export const overiddingRiskFactorDetails = (data) => {
    return {
        type: FETCH_OVERIDDING_RISKFACTOR_DETAILS,
        data
    }
}
export const overiddingRiskFactorDetailsSuccess = (data) => {
    return {
        type: FETCH_OVERIDDING_RISKFACTOR_DETAILS_SUCCESS,
        data
    }
}
export const overiddingRiskFactorDetailsFailure = (data) => {
    return {
        type: FETCH_OVERIDDING_RISKFACTOR_DETAILS_FAILURE,
        data
    }
}

export const EDIT_OVERRIDDING_RISKFACTOR = 'src/component/RiskFactor/OverriddingRiskFactor/create/Edit_Overridding_Riskfactor';
export const EDIT_OVERRIDDING_RISKFACTOR_SUCCESSFULL = 'src/component/RiskFactor/OverriddingRiskFactor/create/Edit_Overridding_Riskfactor_Successfull';
export const EDIT_OVERRIDDING_RISKFACTOR_FAILURE = 'src/component/RiskFactor/OverriddingRiskFactor/create/Edit_Overridding_Riskfactor_Failure';

export const editOverriddingRiskFactor = (data) => {
    return {
        type: EDIT_OVERRIDDING_RISKFACTOR,
        data
    }
}
export const editOverriddingRiskFactorSuccess = (data) => {
    return {
        type: EDIT_OVERRIDDING_RISKFACTOR_SUCCESSFULL,
        data
    }
}
export const editOverriddingRiskFactorFailure = (data) => {
    return {
        type: EDIT_OVERRIDDING_RISKFACTOR_FAILURE,
        data
    }
}